import { useCallback, useEffect, useRef, useState } from "react";

const useVisibilityObserver = (containerRef) => {
  const observerRefs = useRef({});
  const [visibleIds, setVisibleIds] = useState(new Set());

  const observe = useCallback(
    (id, node) => {
      if (!node) return;

      if (observerRefs.current[id]) observerRefs.current[id].disconnect();

      const observer = new IntersectionObserver(
        ([entry]) => {
          setVisibleIds((prev) => {
            const newSet = new Set(prev);
            const changed = entry.isIntersecting
              ? !newSet.has(id)
              : newSet.has(id);
            if (!changed) return prev;

            if (entry.isIntersecting) newSet.add(id);
            else newSet.delete(id);
            return newSet;
          });
        },
        { root: containerRef.current, threshold: 0.01 }
      );

      observer.observe(node);
      observerRefs.current[id] = observer;
    },
    [containerRef]
  );

  useEffect(() => {
    return () => {
      Object.values(observerRefs.current).forEach((observer) =>
        observer.disconnect()
      );
    };
  }, []);

  return { observe, visibleIds };
};

export default useVisibilityObserver;
